export function nodeContainsClick(node: HTMLElement | null, e: MouseEvent | null): boolean {
  const x = node?.contains(e?.target as Node) ? true : false;
  return x;
}
